import { L } from "../../lib/abpUtility";

export const SubscriptionTypes = {
    organization: -2,
    demo: -1,
    businessBasic: 0,
    businessStandard: 1,
    enterpriseAdvanced: 2,  
    enterpriseUnlimited: 3, 

    organization_Text: L('Organization'),
    demo_Text: L('Demo'),
    businessBasic_Text:L('Business Basic'),
    businessStandard_Text: L('Business Standard'),
    enterpriseAdvanced_Text: L('Enterprise Advanced'),
    enterpriseUnlimited_Text: L('Enterprise Unlimited'),
    
}
